// src/config/apiConfig.js
const BASE_URL = 'https://nfcadmin.mhcockpit.com/api';

const API_ENDPOINTS = {
    PUBLIC_EMPLOYEES: (orgId) => `${BASE_URL}/public/employees/${orgId}/`,
    EMPLOYEE_DETAIL: (id) => `${BASE_URL}/public/employee/${id}/`,
};

export default API_ENDPOINTS;